import React from 'react';
import { WebsiteDesignProps } from './types';
import { Layers, Eye, Archive } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MuseumCollection: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Institute of Art History";

    return (
        <div className="bg-[#faf9f6] min-h-screen font-serif text-[#1a1a1a]">
            <nav className="border-b border-[#e5e5e5] py-8 px-12 flex justify-between items-center bg-white">
                <div className="text-sm uppercase tracking-[0.3em] font-medium text-gray-500">
                    {schoolName}
                </div>
                <div className="hidden md:flex gap-12 text-xs uppercase tracking-[0.2em] font-medium">
                    <a href="#" className="hover:text-gray-500 transition-colors">Collection</a>
                    <a href="#" className="hover:text-gray-500 transition-colors">Exhibitions</a>
                    <a href="#" className="hover:text-gray-500 transition-colors">Visit</a>
                    <a href="#" className="hover:text-gray-500 transition-colors">Learn</a>
                </div>
                <Button variant="ghost" className="text-xs uppercase tracking-[0.2em]">
                    Tickets
                </Button>
            </nav>

            <header className="py-24 px-12 max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-end">
                    <div>
                        <span className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-4 block">
                            Now Open
                        </span>
                        <h1 className="text-5xl md:text-7xl font-light leading-[1.1] mb-8">
                            The Art of <br/> <em>Seeing</em>
                        </h1>
                        <p className="text-lg text-gray-600 leading-relaxed max-w-md">
                            An educational journey through 5,000 years of human creativity. Curated experiences for scholars and curious minds alike.
                        </p>
                    </div>
                    <div className="aspect-[4/5] bg-[#e8e4df] relative overflow-hidden">
                        <img 
                            src="https://images.unsplash.com/photo-1518998053901-5348d3961a04?q=80&w=1974&auto=format&fit=crop" 
                            className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" 
                            alt="Art" 
                        />
                        <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur p-4">
                            <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Featured</div>
                            <div className="font-medium">Renaissance Masters: A Study</div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="bg-white py-20 border-t border-[#e5e5e5]">
                <div className="max-w-6xl mx-auto px-12 grid grid-cols-1 md:grid-cols-3 gap-12">
                    {[
                        { icon: Eye, title: "Guided Tours", desc: "Expert-led explorations of our permanent collection." },
                        { icon: Layers, title: "Study Programs", desc: "In-depth courses for students and educators." },
                        { icon: Archive, title: "Archives", desc: "Access to rare manuscripts and documents." },
                    ].map((item, i) => (
                        <div key={i} className="group cursor-pointer">
                            <item.icon className="text-gray-300 group-hover:text-black transition-colors mb-6" size={32} strokeWidth={1} />
                            <h3 className="text-lg font-medium mb-2">{item.title}</h3>
                            <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default MuseumCollection;
